import React from 'react';
import ReactDOM from 'react-dom/client';
import '../index.scss';
import { HashRouter,Routes,Route } from 'react-router-dom';
import LandingPage from './page/LandingPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HashRouter>
    <Routes>
      <Route path='/' element={<LandingPage/>}></Route>
    </Routes>
  </HashRouter>
);
